import type { FC } from "react";
import { useNavigate } from "react-router";

import { TerminalBatchUpdateButton } from "src/app/features/Terminal/components/buttons/TerminalBatchUpdateButton";
import { TerminalBatchUpdateCsvModal } from "src/app/features/Terminal/components/buttons/TerminalBatchUpdateCsvModal";
import { TerminalDeleteButton } from "src/app/features/Terminal/components/buttons/TerminalDeleteButton";
import { TerminalSearchForm } from "src/app/features/Terminal/components/forms/TerminalsSearchForm";
import { TerminalsTable } from "src/app/features/Terminal/components/tables/TerminalsTable";
import type { TerminalList } from "src/app/features/Terminal/types/TerminalList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { Permissions } from "../../../../core/router/config/Permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";
import type { NoneOwnProps } from "../../../../core/types";
import { TerminalBatchAddButton } from "../components/buttons/TerminalBatchAddButton";

export const TerminalsPage: FC<NoneOwnProps> = () => {
    const table = <TerminalsTable />;
    const searchForm = <TerminalSearchForm />;
    const hasAccess = canAccess(ResourceName.TERMINALS, "canRead");
    const navigate = useNavigate();

    const formCopyCallback = (item: TerminalList) => {
        navigate(`${BASE_PATH}/${ResourceName.TERMINALS}/${FORM_ACTION.COPY}/${item.id}`, {
            state: { siteId: item.siteId },
        });
    };

    return (
        <PageLayout name="terminals_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.terminals" />
                    <ResourceManager<TerminalList>
                        useDataGroup
                        dataMapperKey="terminalTableData"
                        resource={ResourceName.TERMINALS}
                        table={table}
                        searchForm={searchForm}
                        actionCallbacks={{ formCopy: formCopyCallback }}
                        customActions={[
                            {
                                action: <TerminalDeleteButton />,
                                permission: Permissions.DELETE,
                            },
                            {
                                action: <TerminalBatchUpdateCsvModal />,
                                permission: "batchUpdateCsv",
                            },
                            {
                                action: <TerminalBatchAddButton />,
                                permission: "batchAdd",
                            },
                            {
                                action: <TerminalBatchUpdateButton />,
                                permission: "batchUpdate",
                            },
                        ]}
                        actions={[Actions.ADD, Actions.FORM_COPY, Actions.EXPORT, Actions.IMPORT_DATA]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
